import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { RenderPageNumbers } from "../../containers/PatientOverviewPage/PageNumbers";
import ArrowButton from "../ArrowButton/ArrowButton";
import { Paginator } from "./Paginator";

export class Pagination extends Component {
  state = {
    currentPage: 0,
    pageNumbers: 0,
  };

  componentDidMount() {
    if (!this.props.url) {
      throw new Error("URL not supplied!");
    }

    this.update();
  }

  handleCurrentPage = e => {
    e.persist();
    this.setState({ currentPage: Number(e.target.id) });

    if (this.state.currentPage !== Number(e.target.id)) {
      this.updatePagination(e.target.id * this.props.limit);
    }
  };

  onNext = () => {
    this.setState(
      prevState => {
        const newPage = prevState.currentPage + 1;
        // TODO: This.state.pageNumbers must be removed
        // TODO: pagNumbers must be calculated in Paginator.js
        if (newPage < prevState.pageNumbers) {
          return { currentPage: newPage };
        }
        return {};
      },
      () => this.update(),
    );
  };

  onPrevious = () => {
    this.setState(
      prevState => {
        const newPage = prevState.currentPage - 1;

        if (newPage >= 0) {
          return { currentPage: newPage };
        }

        return {};
      },
      () => this.update(),
    );
  };

  update() {
    this.updatePagination(this.state.currentPage * this.props.limit);
  }

  async updatePagination(offset) {
    const result = await Paginator(
      this.props.url,
      this.props.filter,
      this.props.limit,
      offset,
    );

    this.handleResult(result);
  }

  handleResult = result => {
    this.setState({ pageNumbers: result.PageNumbers });
    this.props.handleResult(result.list);
  };

  componentWillUnmount() {
    if (this.SearchTimeout !== -1) {
      clearTimeout(this.SearchTimeout);
    }
  }

  SearchTimeout = -1;

  componentDidUpdate(prevProps) {
    if (prevProps.filter !== this.props.filter) {
      if (this.SearchTimeout !== -1) {
        clearTimeout(this.SearchTimeout);
      }

      if (this.props.disableTimeout) {
        this.update();
        return;
      }

      this.SearchTimeout = setTimeout(() => {
        this.setState({ currentPage: 0 });

        this.update();
      }, 300);
    }
  }

  isLeftDisabled() {
    return this.state.currentPage <= 0;
  }

  isRightDisabled() {
    return this.state.currentPage >= this.state.pageNumbers - 1;
  }

  render() {
    return (
      <Wrapper>
        <ArrowButton
          left
          onClick={this.onPrevious}
          disabled={this.isLeftDisabled()}
          id="previous-pagination-page"
        />

        <List>
          <RenderPageNumbers
            currentPage={this.state.currentPage}
            pageNumbers={this.state.pageNumbers}
            onClick={this.handleCurrentPage}
          />
        </List>
        <ArrowButton
          onClick={this.onNext}
          disabled={this.isRightDisabled()}
          id="next-pagination-page"
        />
      </Wrapper>
    );
  }
}

Pagination.propTypes = {
  handleResult: PropTypes.func,
  filter: PropTypes.any,
  limit: PropTypes.number,
  url: PropTypes.string,
  disableTimeout: PropTypes.bool,
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  min-height: 34px;
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default Pagination;
